import * as React from 'react';
import { SVGProps } from 'react';

export const Table = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4454_84562)">
      <path
        d="M31.8267 11.8867L27.0265 6.55326C26.8998 6.41325 26.7198 6.33325 26.5332 6.33325H5.46594C5.27925 6.33325 5.09925 6.41325 4.97262 6.55326L0.172486 11.8867C-0.0742086 12.16 -0.054208 12.58 0.219174 12.8267C0.339178 12.9401 0.499182 13.0001 0.665874 13.0001H3.99928V25.0004C3.99928 25.3671 4.29929 25.6671 4.66598 25.6671C5.03268 25.6671 5.33269 25.3671 5.33269 25.0004V13.0001H7.99945V19.0002C7.99945 19.3669 8.29946 19.6669 8.66616 19.6669C9.03285 19.6669 9.33286 19.3669 9.33286 19.0002V13.0001H23.3332V19.0002C23.3332 19.3669 23.6333 19.6669 24 19.6669C24.3666 19.6669 24.6667 19.3669 24.6667 19.0002V13.0001H27.3334V25.0004C27.3334 25.3671 27.6334 25.6671 28.0001 25.6671C28.3668 25.6671 28.6668 25.3671 28.6668 25.0004V13.0001H31.3336C31.7003 13.0001 32.0003 12.7001 32.0003 12.3334C32 12.1667 31.94 12.0067 31.8267 11.8867ZM2.15917 11.6667L5.75926 7.6666H26.2331L29.8332 11.6667H2.15917Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4454_84562">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Table;
